import React, { useRef, useState } from 'react';
import api from '../utils/api';
import { resolvePublicPreviewUrl } from '../utils/previewAccess';

export default function PublicPreviewLink({ generationId }: { generationId: string }) {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const createLink = async () => {
    if (loading) return;
    setLoading(true); setMessage('');
    try {
      const response = await api.post(`/api/generation/preview-v2/${encodeURIComponent(generationId)}/public-link`);
      if (!response.data?.success || !response.data?.publicUrl) throw new Error('Ссылка не получена');
      // Абсолютная ссылка (отдельный origin превью) остаётся как есть; относительная — от baseURL API.
      const publicUrl = resolvePublicPreviewUrl(response.data.publicUrl, api.defaults?.baseURL || window.location.origin);
      if (!publicUrl) throw new Error('Ссылка не получена');
      setUrl(publicUrl);
    } catch (error) {
      setMessage((error as { response?: { data?: { error?: string } } }).response?.data?.error || 'Не удалось получить публичную ссылку. Попробуйте ещё раз.');
    } finally { setLoading(false); }
  };
  const copyLink = async () => {
    try { await navigator.clipboard.writeText(url); setMessage('Ссылка скопирована.'); }
    catch { inputRef.current?.focus(); inputRef.current?.select(); setMessage('Ссылка выделена — скопируйте её.'); }
  };

  return <div className="wp-publicLink">
    <button type="button" className="u2-btn is-secondary" disabled={loading} onClick={createLink}>{loading ? 'Получаем ссылку…' : 'Публичная ссылка'}</button>
    {url && <div className="wp-publicLinkDetails">
      <label>Ссылка без авторизации · действует 24 часа<input ref={inputRef} className="u2-input" readOnly value={url} onFocus={event => event.currentTarget.select()} /></label>
      <div className="u2-toolbarGroup"><button type="button" className="u2-btn is-secondary" onClick={copyLink}>Скопировать</button><a className="u2-btn is-success" href={url} target="_blank" rel="noopener noreferrer">Открыть сайт</a></div>
    </div>}
    {message && <p role="status" className="u2-muted">{message}</p>}
  </div>;
}
